<template>
  <b-container>
    <b-container fluid="sm" style="padding-top: 20px">
      <b-card bg-variant="light">
        <group-selector v-model="selectedGroups" :available-groups="groupsList" :show-ids="true"></group-selector>

        <b-form-group label-cols="4" label-cols-lg="2" label-size="md" label="First Name" label-for="input-first-name">
          <b-form-input id="input-first-name" size="sm" v-model="firstName"/>
        </b-form-group>

        <b-form-group label-cols="4" label-cols-lg="2" label-size="md" label="Last Name" label-for="input-last-name">
          <b-form-input id="input-last-name" size="sm" v-model="lastName"/>
        </b-form-group>
        <b-form-group label-cols="4" label-cols-lg="2" label-size="md" label="Street Address"
                      label-for="streetAddress">
          <b-form-input id="streetAddress" size="sm" v-model="streetAddress"/>
        </b-form-group>
        <b-form-group label-cols="4" label-cols-lg="2" label-size="md" label="City"
                      label-for="city">
          <b-form-input id="city" size="sm" v-model="city"/>
        </b-form-group>
        <b-form-group label-cols="4" label-cols-lg="2" label-size="md" label="State"
                      label-for="state">
          <b-form-input id="state" size="sm" v-model="state"/>
        </b-form-group>
        <b-form-group label-cols="4" label-cols-lg="2" label-size="md" label="Zip Code"
                      label-for="zipCode">
          <b-form-input id="zipCode" size="sm" v-model="zipCode"/>
        </b-form-group>

        <b-form-group label-cols="4" label-cols-lg="2" label-size="md" label="Telephone Number"
                      label-for="telephoneNumber">
          <b-form-input id="telephoneNumber" size="sm" v-model="telephoneNumber"/>
        </b-form-group>


        <b-form-group label-cols="4" label-cols-lg="2" label-size="md" label="Email " label-for="input-email">
          <b-form-input id="input-email" size="sm" v-model="email"/>
        </b-form-group>

        <b-form-group label-cols="4" label-cols-lg="2" label-size="md" label="Username" label-for="input-username">
          <b-form-input id="input-username" size="sm" v-model="username"/>
        </b-form-group>
        <b-form-group label="Admin Roles:" v-slot="{ ariaDescribedby }">
          <b-form-checkbox-group
              id="groupRoles"
              v-model="roles"
              :options="rolesOptions"
              stacked
              :aria-describedby="ariaDescribedby"
              name="groupRoles">
          </b-form-checkbox-group>
        </b-form-group>
        <b-form-group label="User Status:" v-slot="{ ariaDescribedby }">
          <b-form-radio-group
              id="accountStatus"
              v-model="enabled"
              :options="statusOptions"
              :unchecked-value="false"
              stacked
              :aria-describedby="ariaDescribedby"
              name="accountStatus">
          </b-form-radio-group>
        </b-form-group>
        <b-container fluid="sm">
          <div class="button-holder">
            <b-button class="submit-button" type="submit" @click="submit('userInfo')"
                      :disabled="!canSubmit" variant="primary">
              Update
            </b-button>

            <b-button class="cancel-button" type="cancel" @click="cancel" variant="primary">Cancel
            </b-button>
          </div>
        </b-container>
      </b-card>
    </b-container>
  </b-container>

</template>

<script>
import GroupSelector from "@/components/admin/GroupSelector";

const emailRegex = /^([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})$/i;

export default {
  name: "UpdateUser.vue",
  props: {
    groupId: String,
    userId: String
  },
  components: {
    GroupSelector
  },
  data() {
    return {
      myGroupId: this.groupId || localStorage.getItem('adminImpersonationGroupId') || localStorage.getItem('groupId'),
      theUserId: this.userId,
      groupList: [],
      createdUserGroup: [],
      roles: ['USER'],
      companyName: '',
      firstName: '',
      lastName: '',
      streetAddress: '',
      city: '',
      state: '',
      zipCode: '',
      telephoneNumber: '',
      username: '',
      email: '',
      enabled: 'ENABLED',
      errors: [],
      isSubmitted: true,
      rolesOptions: ['admin', 'THIRD_PARTY_CERTIFIER', "VINEYARD_ADMIN"],
      statusOptions: ['ENABLED', 'DISABLED'],
      groups: [],
      selectedGroups: [],
      /*groupCols: [{key: 'selected', label: 'Selected'}, {key: 'id', label: 'ID'},
        {key: 'name', label: 'Name'}, {key: 'groupAdminRole', label: 'Group Admin'}],*/
      groupsList: [],
      groupRoleList: []
    }
  },
  computed: {
    computedCompany: function () {
      let self = this;
      if (this.groupList) {
        let company = this.groupList.find(function (val) {
          return val.id === self.createdUserGroup;
        });
        this.companyName = company ? company.name.split("(")[0] : "";
        return company ? company.name : "";
      }
      return "";
    },
    validateBusinessName: function () {
      return this.createdUserGroup !== null;
    },
    validateFirstName: function () {
      return this.firstName !== '';
    },
    validateLastName: function () {
      return this.lastName !== '';
    },
    validateTelephoneNumber: function () {
      return this.telephoneNumber !== '';
    },
    validateContactEmail: function () {
      return this.validateEmailAddress(this.email);
    },
    validateUsername: function () {
      return this.username !== '';
    },
    canSubmit: function () {
      return this.validateContactEmail && this.validateTelephoneNumber
          && this.validateFirstName && this.validateLastName && this.validateBusinessName
          && this.validateUsername && this.createdUserGroup.length > 0;
    }
  },
  beforeMount() {
    console.log("About To mount");
    let self = this;
    this.$http.get('account/role-types')
        .then(result => {
          if (result.status === 200) {
            self.rolesOptions = result.data.map(val => {
              if (val === 'ADMIN') {
                return {text: val, value: val.toLowerCase()};
              }
              return {text: val, value: val};
            });
          }
        })
        .catch(error => {
          console.log("Unable to retrieve roles, falling back.", error);
        });
    this.$http.get(`/account/user/id/${this.theUserId}/new`)
        .then(response => {
          let userInfo = response.data;
          self.firstName = userInfo.firstName;
          self.lastName = userInfo.lastName;
          self.company = userInfo.company;
          self.streetAddress = userInfo.streetAddress;
          self.city = userInfo.city;
          self.state = userInfo.state;
          self.zipCode = userInfo.zipCode;
          self.telephoneNumber = userInfo.telephoneNumber;
          self.username = userInfo.username;
          self.email = userInfo.email;
          self.groups = userInfo.groupRoleList.map(item => item.groupId);
          self.roles = userInfo.groupRoleList.map(item => item.role);
          self.groupRoleList = userInfo.groupRoleList;
        })
        .catch(error => {
          alert("Unable to retrieve User");
          alert(error)
        });

    this.$http.get("groups")
        .then(resp => {
          self.groupList = resp.data;

          let myGroups = self.groupList.filter(group => {
            return self.groups.includes(group.id);
          })
              .map(group => {
                group.selected = true;
                let groupRoles = self.groupRoleList.filter(groupRole => {
                  return groupRole.groupId === group.id;
                })
                    .map(val => {
                      return val.role
                    });
                group.groupAdminRole = groupRoles.includes("GROUP_ADMIN");
                group.viewer = groupRoles.includes("VIEWER");
                return group;
              });
          self.createdUserGroup = JSON.parse(JSON.stringify(myGroups));
          this.selectedGroups.push(...self.createdUserGroup);
        })
        .catch(error => {
          this.displayResult(`Unable to load user groups with error: ${error}`, 'error');
        });

    this.loadAccessibleGroups();

  },
  methods: {
    loadAccessibleGroups: function () {
      console.log("Getting list of groups can add to");
      let self = this;
      this.$http.get(`account/user/${localStorage.getItem('user')}/group-admin`)
          .then(result => {
            let adminGroups = [];
            let groupsSet = Object.entries(result.data);
            groupsSet.forEach(group => {
              adminGroups.push({
                selected: self.groups.includes(group[0]),
                id: group[0],
                name: group[1],
                groupAdminRole: self.groups.includes(group[0]) && self.groupRoleList.filter(groupItem => groupItem.groupId === group[0]).map(it => it.role).includes("GROUP_ADMIN"),
                viewer: self.groups.includes(group[0]) && self.groupRoleList.filter(groupItem => groupItem.groupId === group[0]).map(it => it.role).includes("VIEWER")
              })
            });
            self.groupsList = adminGroups;
          }).catch(err => {
        console.log('Error Caught');
        console.log(err.reason);
        console.log(err);
      });
    },
    validateEmailAddress: function (email) {
      return emailRegex.test(String(email).toLowerCase());
    },
    isFieldValid: function (fieldValue, defaultValue) {
      console.log(Object.keys(fieldValue));
      return fieldValue !== defaultValue && fieldValue !== "";
    },
    submit: function () {
      let self = this;
      let data;
      let url;

      url = 'account';
      data = {
        _id: this.theUserId,
        firstName: this.firstName,
        lastName: this.lastName,
        telephoneNumber: this.telephoneNumber,
        company: this.companyName,
        streetAddress: this.streetAddress,
        city: this.city,
        state: this.state,
        zipCode: this.zipCode,
        username: this.username,
        email: this.email,
        groupRoleList: this.selectedGroups.map(group => {
          let roles = ["USER"];
          if (group.groupAdminRole) {
            roles.push("GROUP_ADMIN")
          }
          if (group.viewer) {
            roles.push("VIEWER")
          }
          return roles.map(theRole => {
            return {role: theRole, groupId: group.id}
          });
        })
            .flat(),
        enabled: this.enabled === "ENABLED"
      };
      console.log(`Posting data to the following url: ${url}`);
      this.$http.put(url, data, {
        headers: {
          'content-type': 'application/json'
        }
      })
          .then(function (response) {
            if (response.status === 202 || response.status === 200) {
              self.displayResult(`Account Updated successfully.`, 'success');
            }
          })
          .catch(function (error) {
            let issuesObject = error.response.data !== undefined ? error.response.data[0] : "unknown";
            self.displayResult("Account Update Failed", `Update failed, user with ${issuesObject.field} = ${issuesObject.value} already exists.`, "error");
          });
      console.log(data);
    },
    clearForm: function () {
      this.firstName = '';
      this.lastName = '';
      this.company = '';
      this.streetAddress = '';
      this.city = '';
      this.state = '';
      this.zipCode = '';
      this.telephoneNumber = '';
      this.username = '';
      this.email = '';
      this.createdUserGroup = [];
      this.roles = []
    },
    cancel: function () {
      this.$router.push({path: '/users'});
    },
    displayResult: function (message, type) {
      let iconId;
      if ('success' === type.toLowerCase()) {
        iconId = 'fa-check-circle';
      } else {
        iconId = 'fa-exclamation-triangle';
      }
      this.$toasted.show(message,
          {
            containerClass: 'super-toasty',
            iconPack: 'fontawesome',
            closeOnSwipe: true,
            action: {
              text: 'DISMISS',
              onClick: (e, toastObject) => {
                toastObject.goAway(0);
              }
            },
            icon: {
              name: `${iconId}`, //'fa-check-circle',
              after: false,
            }
          })
          .goAway(5000);
    }
  }
}
</script>

<style scoped>
.cancel-button {
  margin-left: 10px;
  margin-top: 5px;
}

.submit-button {
  margin-left: 10px;
  margin-top: 5px;
}

.button-holder {
  horiz-align: center;
  display: flex; /*Requires vendor prefixes*/
  justify-content: center; /*Requires vendor prefixes*/
  align-items: center; /*Requires vendor prefixes*/
}
</style>
